import TeacherPortalLearningMaterialUsageTimelineChart from "./LearningMaterialUsageTimeLineChart";

const TeacherPortalLearningMaterialUsage = ({ activityWithUsageData }) => (
    <section className="rounded bg-white p-2 shadow-default">
        <h2 className="text-lg font-semibold">Usage Timeline (of all users)</h2>
        {activityWithUsageData.use_data.length > 0 ?
            <TeacherPortalLearningMaterialUsageTimelineChart activityWithUsageData={activityWithUsageData} /> :
            <p className="text-left text-sm">As this learning material has not been used yet, there is no timeline available.</p>}
    </section>
);

export default TeacherPortalLearningMaterialUsage;
